import React, {useState} from 'react';
import {JsonEditor} from 'jsoneditor-react';
import {changeEditMode} from '@pluto/utils';
import {curry} from 'ramda';
import wrap from 'wraptile';
import Tooltip from '@material-ui/core/Tooltip';
import ReactJson from 'react-json-view';
import 'jsoneditor-react/es/editor.min.css';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import './JsonEditor.scss';

type BluEvoData = {
    [key: string]: any;
};

interface BlueEvoProps {
    id: string;
    data: BluEvoData;
    isDeliveryManagerManifest?: boolean;
    isEditable: boolean;
    putIngestData?: (id: string, jsonData: {[key: string]: any}) => void;
}

export const handleJsonChange = curry((setChangedData: (data: BluEvoData) => void, data: BluEvoData) => {
    setChangedData(data);
});

export const handleSave = wrap((
    id: string,
    dataToSave: {[key: string]: any},
    putIngestData: (id: string, jsonData: {[key: string]: any}) => void,
    setIsEditMode: (value: boolean) => void,
) => {
    putIngestData(id, dataToSave);
    setIsEditMode(false);
})

export default function BlueEvo(props: BlueEvoProps) {
    const {
        data,
        isEditable,
        putIngestData,
        id,
        isDeliveryManagerManifest,
    } = props;
    const [changedData, setChangedData] = useState<BluEvoData>(data);
    const [isEditMode, setIsEditMode] = useState<boolean>(false);
    const disabledSaving = false;

    return (
        <div className="ingest-manifest">
            <div className="ingest-manifest__header">
                <div className="ingest-manifest__header_text">
                    Ingest Manifest
                </div>
                {isEditMode ? (
                    <div className="ingest-manifest__buttons">
                        <div
                            className="ingest-manifest__buttons_cancel"
                            onClick={changeEditMode(setIsEditMode, false)}
                            role="button"
                        >
                            Cancel
                        </div>
                        <button
                            onClick={handleSave(id, changedData, putIngestData, setIsEditMode)}
                            className="ingest-manifest__buttons_save"
                            disabled={disabledSaving}
                        >
                            <Tooltip title={disabledSaving ? 'You cannot save invalid json' : ''}>
                                <span>Save and retry ingest</span>
                            </Tooltip>
                        </button>
                    </div>
                ) : (
                    !isDeliveryManagerManifest && (
                        <div className="ingest-manifest__edit-block">
                            {isEditable ? (
                                <BorderColorIcon
                                    className="ingest-manifest__edit-icon"
                                    onClick={changeEditMode(setIsEditMode, true)}
                                />
                            ) : (
                                <Tooltip title="Edit mode is only available for failed ingests">
                                    <BorderColorIcon className="ingest-manifest__edit-icon disabled"/>
                                </Tooltip>
                            )}
                        </div>
                    )
                )}
            </div>
            {isEditMode ? (
                <JsonEditor
                    statusBar={false}
                    navigationBar={false}
                    search={false}
                    value={data}
                    onChange={handleJsonChange(setChangedData)}
                />
            ) : (
                <ReactJson
                    src={data}
                    displayDataTypes={false}
                    displayObjectSize={false}
                />
            )}
        </div>
    );
}
